<!-- 此component用來PDF瀏覽 -->
<template> 
  <div id="pdfvuer" :style="{ 'text-align': 'center', 'margin': 'auto'}">
    <ScaleOut v-show="this.$store.state.pdfLoading" class="loading-icon"></ScaleOut>
    <el-button v-show="this.$store.state.pdfDataLoad" class="fullscreen-btn" :title="fullscreentitle" @click="toggle">
      <img src="../../assets/icon/ic_fullscreen.png" alt="F" class="fullscreen-icon">
    </el-button>
    <div v-show="this.$store.state.pdfDataLoad" id="buttons" class="ui grey three item inverted bottom fixed menu transition">
      <!--<a class="item" @click="page > 1 ? page-- : 1">
        ◂ 前一頁
      </a>-->
      <a class="item">
        {{current}} / {{ totalPage ? totalPage : '∞' }}
      </a>
      <!--<a class="item" @click="page < numPages ? page++ : 1">
        下一頁 ▸
      </a>--> 
    </div>
    <LazyPdfVuer v-show="this.$store.state.pdfDataLoad" :options="pdfOptions" offscreenPages="1" v-on:pageChanged="onPageChanged" />
    <hint v-show="hint.display && this.$store.state.hintStatus.pdfView" :message="hint.message" @close="closeHint"></hint>
    <WaterMark v-if="systemAdminMode === false" v-bind:inputText='inputText'></WaterMark>
    <div v-show="this.$store.state.pdfError" style="margin-top:30px; font-size:18px">
      The file could not be loaded, either because the preview data is processing, please try again later or because the file is not existed or the format is not supported.
    </div>
  </div>
</template>

<script>
import LazyPdfVuer from "./LazyPdfVuer";
import WaterMark from './waterMark';
import API from '../../api/api';
import constant from '../../constant';


export default {
  components: {
    LazyPdfVuer: LazyPdfVuer
  },
  data () {
    return {
      //page: 1,
      current: 0,
      totalPage: 0,
      //pdfdata: null,
      fullscreentitle: "全螢幕",
      infoId: '',
      fileId: '',
      //跳出hint
      hint: {
        message: '',
        display: false,
      },
      timer: null,
      inputText : "",
      systemAdminMode : "",
      fullscreen: false,
    }
  },
  computed: {
    pdfOptions() {
      return {
        url: constant.apiUrl + '/api/science/resources/download/' + this.infoId + '/' + this.fileId + '/pdfpreview',
        httpHeaders: {
          'Authorization' : 'Bearer ' + foxdrive_api.getCookie('access_token'),
          'X-science-site-code' : 'semibookclub'
        }
      };
    }
  },
  mounted () {
    //window.addEventListener('unload', e => this.unloadFn(e));
    API.getUser().then((result) => {
      if(result.status) {
        redirectLogin(result.data);
        if(!JSON.parse(result.request.response).error_msg) {
          this.showHint('取得使用者資訊錯誤!');
        } else {
          this.showHint(JSON.parse(result.request.response).error_msg);
        }
      } else {
        //update username
        this.$store.state.userName = result.name;
        this.inputText = 'Confidential for ' + this.$store.state.userName;

        //取得管理者權限
        API.accountInfo(this.$store.state.userName).then((response) => {
          if(response.status !== 0 && response.status !== 1) {
            
          } else {
            if(response.isManager === 2) {
              this.$store.state.isSystemAdminMode = true;
              this.$store.state.isBackendMode = true;
            } else if(response.isManager === 1) {
              this.$store.state.isSystemAdminMode = false;
              this.$store.state.isBackendMode = true;
            } else {
              this.$store.state.isSystemAdminMode = false;
              this.$store.state.isBackendMode = false;
            }
            this.systemAdminMode = this.$store.state.isSystemAdminMode;
          }
          //this.getPdf();
        });	   
      }
    });
  },
  created() {
    document.addEventListener('fullscreenchange', this.exitHandler);
    document.addEventListener('webkitfullscreenchange', this.exitHandler);
    document.addEventListener('mozfullscreenchange', this.exitHandler);
    document.addEventListener('MSFullscreenChange', this.exitHandler);
    this.$store.state.nowStatus = 5;
    this.$store.state.pdfLoading = true;
    this.$store.state.pdfDataLoad = false;
    this.$store.state.pdfError = false;
    this.$store.state.openTime = 0;
    this.$store.state.closeTime = 0;
    this.infoId = Number(location.hash.split('/')[2].split('&')[0]);
    this.fileId = String(location.hash.split('/')[2].split('&')[1]);
    window.addEventListener('beforeunload', e => this.beforeunloadFn(e));
  },
  beforeDestroy: function() {
    /*
		if(this.$store.state.isBackendMode === false) {
      console.log(document.getElementsByClassName('main')[0].children);
			document.getElementsByClassName('main')[0].removeChild(document.getElementById('_waterMark'));	
    }
    */     
    if(this.$store.state.pdfDataLoad) {
      this.$store.state.closeTime = Math.floor(Date.now() / 1000);
      API.setResourceWatchTime(this.infoId, this.fileId, Math.abs(this.$store.state.closeTime - this.$store.state.openTime)).then((response) => {
        if(response.status) {
          redirectLogin(response.data);
          if(!JSON.parse(response.request.response).error_msg) {
						this.showHint('設定時間錯誤!');
					} else {
						this.showHint(JSON.parse(response.request.response).error_msg);	
					}
        } else {
          
        }
      });
    }
    this.$store.state.pdfDataLoad = false;
  },
  destroyed:function() {
    window.removeEventListener('beforeunload', e => this.beforeunloadFn(e));
  },
  watch: {
    /*
    page: function (p) {
      if( window.pageYOffset <= this.findPos(document.getElementById(p)) || ( document.getElementById(p+1) && window.pageYOffset >= this.findPos(document.getElementById(p+1)) )) {
        console.log(this.page)
        //var target = document.getElementById(p);
        //target.parentNode.scrollTop = target.offsetTop - target.parentNode.offsetTop; 
      }
    }
    */
  },
  methods: {
    /**
      * getPdf 取得PDF content
      * @return none
      */
    getPdf () {
      //let self = this;
      // assign access_token and site_code
      /*
      let headers = {
          'Authorization' : 'Bearer ' + ACCESS_TOKEN,
          'X-science-site-code' : 'semibookclub'
      }
    

      self.pdfdata = pdfvuer.createLoadingTask({
        url: constant.apiUrl + '/api/science/resources/download/' + self.infoId + '/' + self.fileId + '/pdfpreview',
        httpHeaders : headers
      });
      */
      //self.pdfdata.then(pdf => {
        //self.loading = false;
        //self.numPages = pdf.numPages;      
        //window.addEventListener('scroll', () => {
          //changePage();
          //stickyNav(); 
        //}, true);
        
        // Get the offset position of the navbar
        //var sticky = $('#buttons')[0].offsetTop;
        /*
        var sticky = document.getElementById("buttons").offsetTop;

        // Add the sticky class to the self.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
        function stickyNav() {
          var yPos = document.getElementsByClassName('content-container')[0].scrollTop;
          if (window.pageYOffset >= sticky) {
            document.getElementById("buttons").classList.remove("hidden");
          } else {
            document.getElementById("buttons").classList.add("hidden");
          }
        }
        */
       /*
        function changePage () {
          var i = 1, count = Number(pdf.numPages);
          var yPos = document.getElementsByClassName('content-container')[0].scrollTop;
          do {
            if(yPos >= self.findPos(document.getElementById(i)) && yPos <= self.findPos(document.getElementById(i+1))) {
              self.page = i;
            }
            i++;
          } while ( i < count) {
            if (yPos >= self.findPos(document.getElementById(i))) {
              self.page = i;
            }
          }
        }
        */
      //});
    },
    /*
    findPos(obj) {
      if(this.$store.state.nowStatus === 5 && obj) {
        return obj.offsetTop;
      }
    },
    */
    beforeunloadFn(e) {
      if(this.$store.state.pdfDataLoad) {
        this.$store.state.closeTime = Math.floor(Date.now() / 1000);
        let logData = {
          'watchtime': Math.abs(this.$store.state.closeTime - this.$store.state.openTime)
        };
        let headers = {
          type: 'application/json',
          Authorization : 'Bearer ' + foxdrive_api.getCookie('access_token'),
        };
        let blob = new Blob([JSON.stringify(logData)], headers);
        let result = navigator.sendBeacon(constant.apiUrl+ '/api/science/resources/watchtime/' + this.infoId + '/' + this.fileId, blob);
        if (result) { 
          console.log('請求成功排隊等待執行');
        } else {
          console.log('失敗');
        }
      }
      this.$store.state.pdfDataLoad = false;
      /*
      if(this.$store.state.pdfDataLoad) {
        this.$store.state.closeTime = Math.floor(Date.now() / 1000);
        let data = new FormData();
        data.append('watchtime', Math.abs(this.$store.state.closeTime - this.$store.state.openTime));
        data.append('token', foxdrive_api.getCookie('access_token'));
        let result = navigator.sendBeacon(constant.apiUrl + '/api/science/resources/watchtime/' + this.infoId + '/' + this.fileId, data);
        if (result) { 
          console.log('請求成功排隊等待執行');
        } else {
          console.log('失敗');
        }
      }
      this.$store.state.pdfDataLoad = false;
      */
    },
    /**
      * closeHint close hint 視窗
      * @return none
      */
    closeHint: function() {
      this.hint.display = false;
      this.$store.state.hintStatus.pdfView = false;
      clearTimeout(this.timer);
    },
    /**
      * showHint 
      * @param  {string} message - message
      * @return none
      */
    showHint: function(message) {
      if(this.timer) {
				clearTimeout(this.timer);	
			}
      this.hint.display = true;
      this.hint.message = message;	
      this.$store.state.showHint= true;
      this.$store.state.hintStatus.pdfView = true;
      this.timer = setTimeout(()=>{
        if(this.$store.state.showHint) {
            this.$store.state.showHint = false;
            this.$store.state.hintStatus.pdfView = false;
        }
      }, this.$store.state.fadeOutTime);
    },
    toggle: function() {
      this.fullscreen = !this.fullscreen;
      if (this.fullscreen) {
        this.openFullscreen(document.getElementsByClassName('main')[0]);
      } else {
        this.closeFullscreen();
      } 
    },
    openFullscreen: function(document) {
      if (document.requestFullscreen) {
        document.requestFullscreen();
      } else if (document.mozRequestFullScreen) { /* Firefox */
        document.mozRequestFullScreen();
      } else if (document.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        document.webkitRequestFullscreen();
      } else if (document.msRequestFullscreen) { /* IE/Edge */
        document.msRequestFullscreen();
      }
      this.fullscreentitle = "離開全螢幕";
    },
    closeFullscreen: function() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }
      this.fullscreentitle = "全螢幕";
    },
    exitHandler: function() {
      if(!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        this.fullscreen = false;
        this.fullscreentitle = "全螢幕";
      }
    },
    onPageChanged({ currentPage, numPages }) {
      this.current = currentPage;
      this.totalPage = numPages;
    }
  }
}
</script>

<style lang="css">
  #buttons {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  /* Page content */
  .content {
    padding: 16px;
  }
  .ui.menu.fixed {
    width : 99% !important;
  }
  .loading-icon {
		height: 60px !important;
		width: 60px !important;
    margin-top: 20%;
    background-color: #1D2327 !important;
	}
  .fullscreen-btn {
    margin: 5px 5px;
    position: fixed;
    z-index: 1;
    display: block;
    background-color: RGBA(255, 255, 255, 0.4);
    border-color: RGBA(255, 255, 255, 0.4);
    width: 60px !important;
    height: 60px !important;
    right: 2%;
  }
  .page {
    margin: auto !important;
  }
  .fullscreen-btn:focus {
    border: none !important;
    outline: none !important;
  }
  .fullscreen-icon {
    margin: -5px -5px;
    display: inline-block;
    vertical-align: middle;
    width: 36px !important;
    height: 36px !important;
	}	
  .ui.inverted.grey.menu {
    background-color: #ffffff !important;
  }
  .ui.inverted.menu .item {
    color: #000000 !important; 
    font-weight: 600;
    font-size: 18px;  
  }
</style>


// WEBPACK FOOTER //
// PDF.vue?5ed56e62